export const DEFAULT_SEO = {
  title: 'Panda Campus - 英国华人留学生二手交易平台 | 全英校园闲置买卖',
  description:
    'Panda Campus 是专属英国华人留学生的二手交易平台，按学校/城市分圈子，同学之间买卖闲置，安全又方便。家具、教材、电器、日用品应有尽有，注册即可免费发布。'
};

export const ROUTE_SEO = {
  home: {
    title: 'Panda Campus - 英国华人留学生二手交易平台 | 全英校园闲置买卖',
    description:
      'Panda Campus 是专属英国华人留学生的二手交易平台，按学校/城市分圈子，同学之间买卖闲置，安全又方便。家具、教材、电器、日用品应有尽有，注册即可免费发布。'
  },
  nearby: {
    title: '校园二手闲置交易 - 家具/教材/电器 | Panda Campus',
    description:
      '浏览各英国高校华人同学发布的二手闲置好物，按学校圈子分类，家具、教材、电器、日用品应有尽有。同校同城交易更放心，直接 WhatsApp 联系卖家。'
  },
  'wanted-list': {
    title: '求购信息 - 华人同学在找什么 | Panda Campus',
    description:
      '没找到想要的二手好物？发布求购帖，让身边同学主动联系你。浏览各校同学的求购信息，看看谁的闲置正好是你需要的。'
  },
  profile: {
    title: '我的主页 | Panda Campus',
    noindex: true
  },
  'product-detail': {
    title: '二手闲置商品详情 | Panda Campus',
    description:
      '查看这件二手闲置好物的详情信息，直接通过 WhatsApp 联系卖家，同校同城交易更安心放心。'
  }
};

function upsertMeta(attrName, attrValue, content) {
  if (content == null || content === '') return;
  var selector = 'meta[' + attrName + '="' + attrValue + '"]';
  var el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(attrName, attrValue) {
  var el = document.querySelector('meta[' + attrName + '="' + attrValue + '"]');
  if (el) el.parentNode.removeChild(el);
}

export function setPageSeo(options) {
  var seo = options || {};
  document.title = seo.title || DEFAULT_SEO.title;

  upsertMeta('name', 'description', seo.description || DEFAULT_SEO.description);

  if (seo.noindex) {
    upsertMeta('name', 'robots', 'noindex, nofollow');
  } else {
    removeMeta('name', 'robots');
  }
}

export function applyRouteSeo(route) {
  if (!route || !route.name) return;
  var seo = ROUTE_SEO[route.name];
  if (!seo) return;
  setPageSeo(seo);
}

export function setProductDetailSeo(product) {
  if (!product) {
    setPageSeo(ROUTE_SEO['product-detail']);
    return;
  }

  var title = String(product.title || '').trim();
  var circle = String(product.circleTitle || product.momo || product.city || '').trim();
  var price = String(product.price || '').trim();

  if (title && circle) {
    setPageSeo({
      title: title + ' - ' + circle + '二手出售 | Panda Campus',
      description:
        circle + '同学出售 ' + title + '，' + (price || '价格面议') + '。通过 WhatsApp 直接联系卖家，同校交易更安心。'
    });
    return;
  }

  if (title) {
    setPageSeo({
      title: title + ' - 二手出售 | Panda Campus',
      description:
        '同学出售 ' + title + '，' + (price || '价格面议') + '。通过 WhatsApp 直接联系卖家，同校交易更安心。'
    });
    return;
  }

  setPageSeo(ROUTE_SEO['product-detail']);
}
